module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.5e809c17f25d1cf3fb68.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto-v15-latin-regular.svg
// module id = 658
// module chunks = 7